import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';
import { useShareScreenToggle } from '@gem/call/CallView/hooks/useShareScreenToggle/useShareScreenToggle';

interface IGroupVideoCallPresenter {
  call: Call;
}

export const useGroupVideoCallPresenter = (): IGroupVideoCallPresenter => {
  useShareScreenToggle();
  const context = useCallContext();

  return useLocalObservable<IGroupVideoCallPresenter>(() => ({
    get call(): Call {
      return context.call;
    },
  }));
};
